import { itemContext, sectionContext, pageContext } from 'context'
import { format, sub, eachDayOfInterval } from 'date-fns'

import { Item } from 'schema'
import moment from 'moment-timezone'
import _ from 'lodash'
import { moduleContext, commandContext } from 'context'

class Data {
    constructor(data, user){
        this.data = data
        this.user = user
        this.options = {
            page: [...Object.values(pageContext.STATUS)],
            section: [...Object.values(sectionContext.STATUS)],
            item: [...Object.values(itemContext.STATUS)]
        }
        this.regex = {
            created: new RegExp('\\b(created|new)'),
            schedule: new RegExp('\\b(start|end|schedule|due)'),
            completed: new RegExp('\\b(completed|done)'),
            all: new RegExp('\\b(created|new|start|end|schedule|due)'),
            special: new RegExp('\\b(today|tomorrow|this week|next week)'),
        }
    }

    traverseChildren(item, func) {
        const childrenIDs = item['item_children']
        childrenIDs && this.options.item.map(itemStatus => {
            const itemIDs = childrenIDs[itemStatus] && Object.values(childrenIDs[itemStatus])
            itemIDs && itemIDs.map(itemID => {
                let childItem = item['children'][itemID]
                let item_details = childItem['item_details']
                item_details['itemID'] = itemID
                item_details['children'] = childItem.item_children
                childItem = new Item(item_details)
                func(childItem)
                childItem['item_children'] && this.traverseChildren(childItem, func)
            })
        })
    }

    traverse(func, options = this.options){
        // Function to return boolean to determine whether to continue
        // console.log('[Data.js]',{data: this.data, options: options, function: func})

        // Pages
        const pageIDs = Object.values(this.data['page_order'])
        pageIDs.map(pageID => {
            const page = this.data['pages'][pageID]
            if(this.options.page.includes(page['page_details']['status'])){

                // Sections
                const sectionIDs = Object.values(page['page_details']['page_sections'])
                sectionIDs.map(sectionID => {
                    const section = page['sections'][sectionID]
                    if(this.options.section.includes(section['section_details']['status'])){

                        // Items
                        const rootItemIDs = section['section_details']['section_children']
                        rootItemIDs && this.options.item.map(itemStatus => {
                            const itemIDs = rootItemIDs[itemStatus] && Object.values(rootItemIDs[itemStatus])
                            if(itemIDs){
                                itemIDs.map(itemID => {
                                    let rootItem = section['section_items'][itemID]
                                    let item_details = rootItem['item_details']
                                    item_details['itemID'] = itemID
                                    item_details['children'] = rootItem.item_children
                                    rootItem = new Item(item_details)
                                    func(rootItem)
                                    
                                    // Child items
                                    this.traverseChildren(rootItem, func)
                                })
                            }
                        })
                    }
                })
            }
        })
    }

    getStatsHandler(item, stats, dateData){
        // Overall stats
        stats['total'] += 1
        item['status'] === itemContext.STATUS.INCOMPLETE && stats['incomplete'] ++
        item['status'] === itemContext.STATUS.COMPLETED && stats['completed'] ++

        // Bar chart data
        const start = sub(new Date(), {months: 1})

        // Created
        const created = new Date(item['create_date'])
        if(created >= start){
            const formattedDate = format(created, 'eee d/M')
            dateData[formattedDate]['y'] += 1
            dateData[formattedDate]['data']['created'].push(item)
        }

        // Completed
        const completed = item['status'] === itemContext.STATUS.COMPLETED && new Date(item['completed_date'])
        if(completed >= start){
            const formattedDate = format(completed, 'eee d/M')
            dateData[formattedDate]['y'] += 1
            dateData[formattedDate]['data']['completed'].push(item)
        }
    }

    _getStats() {
        let stats = {
            'total': 0,
            'incomplete': 0,
            'completed': 0
        }

        // Construct dateData
        let dateData = {}
        const start = sub(new Date(), {months: 1})
        const end = new Date()
        const interval = eachDayOfInterval({ start: start, end: end })
        interval.map(date => {
            dateData[format(date, 'eee d/M')] = {
                x: format(date, 'eee d/M'),
                y: 0,
                data: {
                    created: [],
                    completed: [],
                }
            }
        })

        // Traverse though data
        this.traverse((item) => this.getStatsHandler(item,stats, dateData))

        return {stats: stats, dateData: dateData}
    }

    ///////////////////
    // ITEM SUMMARY //
    //////////////////
    getStats() {
        const debug = false;

        // Construct dateData
        let dateData = {}
        const start = sub(new Date(), {months: 1})
        const end = new Date()
        let interval = eachDayOfInterval({ start: start, end: end })
        interval = interval.map(day => format(day, 'LLL d Y'))
        interval.map(date => {
            dateData[date] = {
                date: date,
                x: format(new Date(date), 'eee d/M'),
                y: 0,
                data: {
                    created: [],
                    completed: [],
                }
            }
        })
        // const t0 = performance.now()
        // interval.map(day => {
        //     const completed = Object.values(this.data['items']).filter(item => item['status'] === 'COMPLETED' & (item['completed_date'] && format(new Date(item['completed_date']), 'LLL d Y') === day))
        //     const created = Object.values(this.data['items']).filter(item => format(new Date(item['create_date']), 'LLL d Y') === day)
        //     dateData[day]['data'] = {created: created, completed: completed}
        //     dateData[day]['y'] = completed.length
        // })
        // debug && console.log(`Method 1 ${performance.now() - t0}`)
        console.log(Object.values(this.data['items']).length)
        const t1 = performance.now()
        Object.values(this.data['items']).map(item => {
            const createdDate = format(new Date(item['create_date']), 'LLL d Y')
            const completedDate = item['completed_date'] && format(new Date(item['completed_date']), 'LLL d Y')

            // Created items
            if(Object.keys(dateData).includes(createdDate)){
                let updatedCreated = [...dateData[createdDate]['data']['created']]
                updatedCreated.push(item)
                dateData[createdDate]['data']['created'] = updatedCreated;
            }
            
            // Completed items
            if(Object.keys(dateData).includes(completedDate)){
                let updatedCompleted = [...dateData[completedDate]['data']['completed']]
                updatedCompleted.push(item)
                dateData[completedDate]['data']['completed'] = updatedCompleted;
            }
        })

        interval.map(day => {
            dateData[day]['y'] = dateData[day]['data']['completed'].length
        })

        debug && console.log(`Method 2 ${performance.now() - t1}`)

        return {dateData: dateData}
    }

    ///////////////////////////
    // SEARCH FUNCTIONALITY //
    //////////////////////////
    searchHandler = (item, results, values) => {
        const {
            limit,
            text,
            date,
            tags
        } = values
        try{
            const itemText = item.getPlainText() + ''
            let ids = results['ids']
            const itemID = item['itemID']
            // console.log(values, item)

            // Stop if item already added to results
            if(ids.includes(itemID)){
                return
            }

            // Text handlers
            if(itemText.toLowerCase().includes(text) & results['items'].length !== limit){
                results['items'].push(item)
                results['ids'].push(itemID)
                return
            } 

            // Tag handlers
            if(_.intersection(item['tags'], tags).length > 0){
                results['items'].push(item)
                results['ids'].push(itemID)
                return
            }
            
            // Date handlers
            else if(date !== 'Invalid date') {
                const create_date = item['create_date'] && moment(item['create_date']).format('YYYY-MM-DD')
                const completed_date = item['completed_date'] && moment(item['completed_date']).format('YYYY-MM-DD')
                const start_date = item['start_date'] && moment(item['start_date']).format('YYYY-MM-DD')
                const start_time = item['start_time'] && moment(item['start_time']).format('YYYY-MM-DD')
                const end_date = item['end_date'] && moment(item['end_date']).format('YYYY-MM-DD')
                const end_time = item['end_time'] && moment(item['end_time']).format('YYYY-MM-DD')

                if (this.regex['created'].test(text) & results['created'].length !== limit & [create_date].includes(date)){
                    results['created'].push(item)
                    results['ids'].push(itemID)
                } 
        
                else if (this.regex['completed'].test(text) & results['completed'].length !== limit & [completed_date].includes(date)){
                    results['completed'].push(item)
                    results['ids'].push(itemID)
                } 

                else if (this.regex['schedule'].test(text) & results['dates'].length !== limit & [start_date, start_time, end_date, end_time].includes(date)){
                    results['scheduled'].push(item)
                    results['ids'].push(itemID)
                } 

                else if (!this.regex['all'].test(text) & results['dates'].length !== limit & [start_date, start_time, end_date, end_time].includes(date)){
                    results['scheduled'].push(item)
                    results['ids'].push(itemID)
                } 
            }
        }
            
        catch{
            // console.log('Failed')
        }
            
    }

    search(value, searchLimit){
        const searchValue = value.toLowerCase()
        let dateRef = moment(value)
        const limit = searchLimit || 5
        let results = {
            ids: [],
            access: [],
            modules: [],
            items: [],
            tags: [],
            dates: [],
            created: [],
            completed: [],
            scheduled: [],
            pages: [],
            commands: []
        }

        if(value.trim().length === 0) {
            // 1. Settings shortcuts
            results['commands'] = Object.keys(commandContext)

            // 2. Page modules
            results['modules'] = [pageContext.MODULES.INTEGRATIONS, pageContext.MODULES.SETTINGS, pageContext.MODULES.HOME]

            // 3. Access modules
            results['access'] = this.user['activePageType'] === pageContext.TYPES.PAGES ? ['CALENDAR','HISTORY'] : []
            dateRef = moment().tz(this.user['timezone']).format('ddd, D-MMM YYYY')

            // 4. Pages
            results['pages'] = Object.values(this.data['pages'])

        } else {
            // 1. Settings shortcuts
            for (const [key, command] of Object.entries(commandContext)) {
                command['keywords'].map(keyword => value.includes(keyword) && !results['commands'].includes(key) && results['commands'].push(key))
            }

            // 2. Page modules
            searchValue.includes(pageContext.MODULES.INTEGRATIONS.toLowerCase()) && results['modules'].push(pageContext.MODULES.INTEGRATIONS)
            searchValue.includes(pageContext.MODULES.SETTINGS.toLowerCase()) && results['modules'].push(pageContext.MODULES.SETTINGS)
            searchValue.includes(pageContext.MODULES.HOME.toLowerCase()) && results['modules'].push(pageContext.MODULES.HOME)

            // 3. Check for access modules
            const pageID = this.user['activePageID']
            const pageType = this.user['activePageType']
            const timezone = this.user['timezone']

            let access = []
            Object.keys(moduleContext.ACCESS_MODULES).map(module => {
                if(module !== 'CALENDAR'){
                    switch(pageType){
                        case pageContext.TYPES.PAGES:
                            searchValue.includes(module.toLowerCase()) && access.push(module)
                            break
                        case pageContext.TYPES.MODULES:
                            switch(pageID){
                                case pageContext.MODULES.HOME:
                                    ['HISTORY', 'CALENDAR'].includes(module) & searchValue.includes(module.toLowerCase()) && access.push(module)
                                    break
                                case pageContext.MODULES.INBOX:
                                    ['NOTES', 'HISTORY', 'CALENDAR'].includes(module) & searchValue.includes(module.toLowerCase()) && access.push(module)
                                    break
                                case pageContext.MODULES.CALENDAR:
                                    ['HISTORY', 'CALENDAR'].includes(module) & searchValue.includes(module.toLowerCase()) && access.push(module)
                                    break
                            }
                            break
                    }
                }
            })
            
            // 4. Construct date search
            if(searchValue.includes('today') || searchValue.includes('upcoming') || searchValue.includes('calendar')){
                dateRef = moment().tz(timezone).format('ddd, D-MMM YYYY')
                access.push('CALENDAR')
            } else if (searchValue.includes('yesterday')){
                dateRef = moment().tz(timezone).subtract({days: 1}).format('ddd, D-MMM YYYY')
                access.push('CALENDAR')
            } else if (searchValue.includes('tomorrow')){
                dateRef = moment().tz(timezone).add({days: 1}).format('ddd, D-MMM YYYY')
                access.push('CALENDAR')
            } else {
                if(dateRef.format('ddd, D-MMM YYYY') !== 'Invalid date'){
                    if(dateRef.year() === 2001){
                        dateRef.year(moment().year())
                    }
                    if(dateRef.isAfter(moment(new Date()).subtract(30,'days'))){
                        dateRef = dateRef.format('ddd, D-MMM YYYY')
                        access.push('CALENDAR')
                    }
                }
            }
            results['access'] = access
            
            // 5. Construct tag search
            let tags = []
            Object.values(this.data['tags']).map(tag => {
                if(value.includes(tag['content'].toLowerCase())){
                    tags.push(tag['tagID']) 
                }
            })
            
            // 6. Traverse through items
            const values = {
                text: value, 
                date: dateRef, 
                limit: limit,
                tags: tags
            }
            Object.values(this.data['items']).map(item => this.searchHandler(item, results, values))

            // 7. Traverse through pages
            results['pages'] = Object.values(this.data['pages']).filter(page => page['page_name'].toLowerCase().includes(value))
        }

        
        
        // 8. Export results
        let n = 0
        Object.keys(results).map(key => {
            if(key !== 'ids'){
                n += results[key].length
            }
        })

        return {results: results, date: dateRef, count: n}
    }


}

export default Data;